module.exports = __webpack_public_path__ + "img/activity-1.ae184e63.jpg";